import { type FC } from 'react'
import { CardContent, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import BasicCardButton, {
  type BasicCardButtonProps,
} from '@DS/components/components/foundations/shapes/card/basic/BasicCardButton'
import { type LazyIcon } from '@DS/components/icons/icons.types'

import * as styles from './styles'

type AutocompleteFavoriteProps = {
  elevation?: 'onSurface' | 'elevated'
  label: string
  place: string
  icon: LazyIcon
} & Omit<BasicCardButtonProps, 'elevation'>

const AutocompleteFavorite: FC<AutocompleteFavoriteProps> = ({
  elevation = 'onSurface',
  label,
  place,
  icon: Icon,
  ...rest
}) => {
  const theme = useTheme()

  return (
    <BasicCardButton {...rest} background={elevation === 'elevated' ? 'default' : 'paper'}>
      <CardContent css={styles.container(theme)}>
        <Icon css={styles.icon(theme)} />
        <div css={styles.content}>
          <Typography css={styles.label} variant="caption">
            {label}
          </Typography>
          <Typography css={styles.place(theme)} variant="caption">
            {place}
          </Typography>
        </div>
      </CardContent>
    </BasicCardButton>
  )
}

export default AutocompleteFavorite
